"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.regexp.replace");
require("core-js/modules/es6.string.starts-with");
require("core-js/modules/es6.number.constructor");
var _waves = _interopRequireDefault(require("@/directive/waves"));
var _SwPage = _interopRequireDefault(require("@/views/common/SwPage"));
var _category = require("@/api/goods/category");
var _goods = require("@/api/goods/goods");
var _dishGroup = require("@/api/goods/dishGroup");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  name: 'SecondCategoryList',
  components: {
    SwPage: _SwPage.default
  },
  directives: {
    waves: _waves.default
  },
  props: {
    parentId: {
      type: Number,
      default: null
    },
    parentCategory: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      listLoading: false,
      selectEntity: {},
      showParentAlert: false,
      selectDataQuery: {
        page: 1,
        limit: 10,
        parentId: null,
        keywords: null,
        parentIdNotEqual: 1,
        hasMapping: null,
        menuInfoId: null
      },
      mappingFilter: null,
      selectDataList: [],
      selectDataTotal: 0,
      goodsVisible: false,
      goodsQuery: {
        page: 1,
        limit: 10,
        categoryFirstId: null,
        categorySecondId: null,
        type: null,
        keywords: null
      },
      goodsList: [],
      goodsTotal: 0,
      editVisible: false,
      editForm: {
        id: null,
        categoryName: '',
        categoryCode: '',
        categoryDesc: '',
        menuInfoId: null
      },
      editRules: {
        categoryName: [{
          required: true,
          message: '请输入分组名称',
          trigger: 'blur'
        }],
        categoryCode: [{
          required: true,
          message: '请输入分组编码',
          trigger: 'blur'
        }]
      },
      menuInfos: []
    };
  },
  created: function created() {
    if (this.parentCategory && this.parentCategory.id) {
      this.selectEntity = this.parentCategory;
      this.selectDataQuery.parentId = this.parentCategory.id;
      this.showParentAlert = true;
    } else if (this.parentId) {
      this.selectDataQuery.parentId = this.parentId;
      this.showParentAlert = false;
    }
    this.getSelectDataList();
    this.getDishGroupList();
  },
  watch: {
    parentCategory: {
      handler: function handler(val) {
        if (val && val.id) {
          this.selectEntity = val;
          this.selectDataQuery.parentId = val.id;
          this.showParentAlert = true;
        } else {
          this.selectEntity = {};
          this.selectDataQuery.parentId = null;
          this.showParentAlert = false;
        }
        this.getSelectDataList();
      },
      deep: true
    },
    parentId: function parentId(val) {
      if (val) {
        this.selectDataQuery.parentId = val;
      } else {
        this.selectDataQuery.parentId = null;
      }
      this.getSelectDataList();
    },
    keywords: {
      handler: function handler(val) {
        if (this.useExternalFilter) {
          this.selectDataQuery.keywords = val || null;
        }
      },
      immediate: true
    }
  },
  computed: {
    maxHeight: function maxHeight() {
      return "".concat(window.innerHeight - 272, "px");
    }
  },
  methods: {
    getDishGroupList: function getDishGroupList() {
      var _this = this;
      (0, _dishGroup.queryList)({
        limit: 1000
      }).then(function (res) {
        _this.menuInfos = res.records;
      });
    },
    handleMappingFilterChange: function handleMappingFilterChange(val) {
      if (val === 'unmapped') {
        this.selectDataQuery.hasMapping = 0;
        this.selectDataQuery.menuInfoId = null;
      } else if (val && val.startsWith('mapped_')) {
        this.selectDataQuery.hasMapping = 1;
        this.selectDataQuery.menuInfoId = parseInt(val.replace('mapped_', ''));
      } else {
        this.selectDataQuery.hasMapping = null;
        this.selectDataQuery.menuInfoId = null;
      }
    },
    clearParent: function clearParent() {
      this.selectEntity = {};
      this.selectDataQuery.parentId = null;
      this.showParentAlert = false;
      this.getSelectDataList();
      this.$emit('clearParent');
    },
    retPage: function retPage() {
      this.getSelectDataList();
    },
    handleFilter: function handleFilter() {
      // 应用映射筛选
      this.handleMappingFilterChange(this.mappingFilter);
      this.selectDataQuery.page = 1;
      this.getSelectDataList();
    },
    openGoodsVisible: function openGoodsVisible(row, type) {
      if (type === 1) {
        this.goodsQuery.categoryFirstId = row.id;
        this.goodsQuery.categorySecondId = null;
      } else {
        this.goodsQuery.categoryFirstId = null;
        this.goodsQuery.categorySecondId = row.id;
      }
      this.selectEntity = row;
      this.goodsQuery.type = type;
      this.goodsQuery.page = 1; // 重置分页
      this.goodsQuery.keywords = null; // 清空搜索
      this.showParentAlert = false;
      this.goodsVisible = true;
      this.getGoodsList();
    },
    getGoodsList: function getGoodsList() {
      var _this2 = this;
      this.listLoading = true;
      (0, _goods.queryList)(this.goodsQuery).then(function (response) {
        if (response) {
          _this2.goodsList = response.records;
          _this2.goodsTotal = response.total;
        }
        setTimeout(function () {
          _this2.listLoading = false;
        }, 500);
      }, function () {
        setTimeout(function () {
          _this2.listLoading = false;
        }, 500);
      });
    },
    getSelectDataList: function getSelectDataList() {
      var _this3 = this;
      this.listLoading = true;
      (0, _category.queryList)(this.selectDataQuery).then(function (response) {
        if (response) {
          _this3.selectDataList = response.records;
          _this3.selectDataTotal = response.total;
        }
        setTimeout(function () {
          _this3.listLoading = false;
        }, 500);
      }, function () {
        setTimeout(function () {
          _this3.listLoading = false;
        }, 500);
      });
    },
    openEditDialog: function openEditDialog(id) {
      var _this4 = this;
      (0, _category.getById)(id).then(function (res) {
        _this4.editForm = res.data;
        _this4.editVisible = true;
      });
    },
    saveEntity: function saveEntity() {
      var _this5 = this;
      this.$refs.editFormRef && this.$refs.editFormRef.validate(function (valid) {
        if (valid) {
          (0, _category.update)(_this5.editForm).then(function () {
            _this5.$message.success(_this5.editForm.id ? '编辑成功' : '新增成功');
            _this5.editVisible = false;
            _this5.getSelectDataList();
          }).catch(function () {
            _this5.$message.error('保存失败');
          });
        }
      });
    }
  }
};